<script lang="ts">
import Header from './layout/Header.svelte';
import Intro from './layout/Intro.svelte';
import Approach from './layout/Approach.svelte';
import Gallery from './layout/Gallery.svelte';
import Footer from './layout/Footer.svelte';
</script>

<Header/>

<main>
	<Intro/>
	<Approach/>
	<Gallery/>
</main>

<Footer/>

<style>
	main {
		max-width: 800px;
		margin: 0 auto;
	}
</style>